export default __webpack_public_path__ + "static/media/stairs.5bca6946.svg";